module.exports = "https://static.wmbcdn.com/uniweb/images/384dac08b505b8cfbe5671ca51132fb0.svg";